<template>
  <div class="tab-select">
    <div class="tab-select-box" v-if="type != 8 && type != 9">
      <div class="tab-select-left">
        <ul v-if="hotList.length !== 0">
          <p class="title">特色服务</p>
          <li v-for="item in hotList" :key="item.id">
            <svg-icon icon-name="star" style="color: blue"/>
            <p>
              <a
                :href="`${item.route}?id=${items.id}&parentId=${item.id}`"
                target="_blank"
                >{{ item.channel_name }}</a
              >
            </p>
          </li>
        </ul>
      </div>
      <div class="tab-select-right">
        <ul v-for="item in items.child" :key="item.id">
          <p class="title">
            <a
              :href="`${item.route}?id=${items.id}&parentId=${item.id}`"
              target="_blank"
              >{{ item.channel_name }}</a
            >
          </p>
          <li v-for="k in item.child" :key="k.id">
            <a
              :href="`${k.route}?id=${items.id}&parentId=${item.id}&childId=${k.id}`"
              target="_blank"
              >{{ k.channel_name }}</a
            >
            <div class="my-coll-mark" v-if="k.is_new || k.is_hot">
                <i class="new" v-show="k.is_new">new</i>
                <i class="hot" v-show="k.is_hot">hot</i>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-select-box tab-select-flex" v-else-if="type == 8">
      <div class="tab-select-flex1" v-if="cuxiaoList.length !== 0">
        <a
          :href="`/marketCentre/specialPromotion?id=8&parentId=11`"
          ><p class="title">优惠促销</p></a
        >
        <ul>
          <a
            :href="`/marketCentre/specialPromotion?id=8&parentId=11&specialPromotionId=${item.id}`"
            v-for="item in cuxiaoList"
            :key="item.id"
          >
            <li>
              <div class="icon">惠</div>
              <p>{{ item.detail_title }}</p>
            </li>
          </a>
        </ul>
      </div>
      <div class="tab-select-flex2" v-if="marketList.length !== 0">
        <a
          :href="`/marketCentre/specialPromotion?id=8&parentId=11`"
          target="_blank"
          ><p class="title">活动推荐</p></a
        >
        <div>
          <a
            :href="`/marketCentre/marketingActivityDetail?id=8&parentId=12&detailId=${marketList[0].id}`"
            target="_blank"
          >
            <img :src="marketList[0].img_text" style="width: 140px;height: 160px" />
          </a>
        </div>
      </div>
      <div class="tab-select-flex3">
        <ul>
          <a
            :href="`${item.route}?id=${items.id}&parentId=${item.id}`"
            target="_blank"
            v-for="item in items.child"
            :key="item.id"
          >
            <li>{{ item.channel_name }}</li>
          </a>
        </ul>
      </div>
    </div>
    <div class="tab-select-box" v-else-if="type == 9">
      <div class="tab-select-flex4">
        <ul>
          <a
            :href="`${item.route}?id=${items.id}&parentId=${item.id}`"
            target="_blank"
            v-for="item in items.child"
            :key="item.id"
          >
            <li>{{ item.channel_name }}</li>
          </a>
        </ul>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, ref } from "vue";
import { channelList } from "@/api/api";
export default defineComponent({
  props: {
    type: {
      type: [String, Number],
      default: "",
    },
    items: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup(props) {
    let cuxiaoList: any[] = reactive<any[]>([]);
    const marketList = ref<any[]>([]);
    let hotList: any[] = reactive<any[]>([]);
    if (props.type != 8 && props.type != 9) {
      props.items.child.forEach((el: any) => {
        if (el.is_hot) {
          hotList.push(el);
        }
      });
    }
    if (props.type == 8) {
      channelList({
        channel_id: 11,
        size: 10,
        page: 1,
        is_valid_date: true,
      }).then((res: any) => {
        res.list.forEach((el: any) => {
          cuxiaoList.push(el);
        });
      });
      // 获取市场中心
      channelList({
        channel_id: 12,
        size: 10,
        page: 1,
      }).then((res: any) => {
        marketList.value = res.list
      })
    }
    return {
      cuxiaoList,
      hotList,
      marketList
    };
  },
});
</script>
<style lang="stylus" scoped>
.tab-select {
  display: flex;
  position: absolute;
  top: 70px;
  left: 0;
  width: 1280px;
  max-height: calc(100vh - 80px)
  overflow-y: auto
  color: #333333;
  a {
    color: #333333;

    &:hover {
      text-decoration: none;
      color: #333333;
    }
  }
  background: #ffffff;
  border: 1px solid #eff1f2;
  box-shadow: 1px 1px 1px 0 #eff1f2;
  z-index: 99999;

  .tab-select-box {
    width: 100%;
    height: 100%;
    display: flex;
  }
}

.tab-select-left {
  flex-shrink: 0;
  width: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  background: #eff1f2;
  padding: 30px 20px 0 20px;
  background-size: 100%
  .title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 30px;
    cursor: pointer;
  }

  li {
    display: flex;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .svg-icon {
    position: relative;
    top: 3px;
    flex-shrink: 0;
    font-size: 16px;
    margin-right: 10px;
  }
}

.tab-select-right {
  column-count: 4;
  column-gap: 20px;
  padding: 30px 20px;
  .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
    cursor: pointer;
  }

  ul {
    box-sizing: border-box;
    break-inside: avoid;
    margin-bottom: 20px;
  }

  li {
    font-size: 12px;
    margin-bottom: 10px;
    color: #666666;
    height: auto;
    cursor: pointer;
  }
}
.my-coll-mark {
    color: #ffffff;
    display: flex;
    display: inline-block;
    padding-left: 10px;
    i {
        display: flex;
        align-items: center;
        text-align: center;
        padding: 0 5px;
        line-height: 16px;
        border-radius: 16px;
    }
    .new {
        background: #fd9352;
    }
    .hot {
        background: #dc4320;
    }
}
.tab-select-flex {
  display: flex
  width: 100%
}
.tab-select-flex1, .tab-select-flex2 {
  padding: 30px 20px;
  border-right: 1px solid #eff1f2;
  flex-shrink: 0
  a {
    color: #333333;

    &:hover {
      text-decoration: none;
    }
  }

  .title {
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
  }
}

.tab-select-flex1 {
  padding-left: 80px;

  li {
    display: flex;
    font-size: 14px;
    margin-bottom: 20px;

    .icon {
      position: relative;
      display: inline-block;
      display: flex;
      align-items: center;
      flex-shrink: 0;
      height: 18px;
      min-width: 38px;
      background: #f4621b;
      margin-right: 20px;
      padding-left: 10px;
      color: #ffffff;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        right: -9px;
        border-top: 9px solid transparent;
        border-left: 9px solid #f4621b;
        border-bottom: 9px solid transparent;
      }

      span {
        font-size: 12px;
        margin-left: 3px;
      }
    }
  }
}

.tab-select-flex2 img {
  width: 100%;
}

.tab-select-flex3 {
  flex: 1
  font-size: 14px;
  color: #666666;
  padding: 30px 80px 20px 0;
  ul {
    flex: 1
    display: flex
    flex-wrap: wrap
    a {
      width: 25%
      display: inline-block
      color: #666666;
      text-decoration: none;
      &:nth-child(4) {
        li {
          border-right: 0
        }
      }
      &:last-child {
        li {
          border-right: 0
        }
      }
      &:hover {
        text-decoration: none;
        color: #666666;
      }
    }
  }

  li {
    text-align: center;
    border-right: 2px solid #cccccc;
    margin-bottom: 25px;
    cursor: pointer;
  }
}

.tab-select-flex4 {
  width: 100%;
  font-size: 14px;
  color: #666666;
  padding-top: 20px;
  ul {
    width: 100%;
    display: flex;
    a {
      flex: 1;
      color: #666666;
      text-decoration: none;
      &:hover {
        text-decoration: none;
        color: #666666;
      }
      &:last-child {
        li {
          border-right: 0
        }
      }
    }
    li {
      text-align: center
      border-right: 2px solid #cccccc
      margin-bottom: 25px
    }
  }
}
@media only screen and (max-width: 1500px) {
  .tab-select {
    position: fixed;
    width: 100%
    left: 50%
    transform: translateX(-50%)
  }
}
</style>